export const getClasses = ({ text, size = 'large', color = 'primary', variant, isRounded }) => {
  const isNumber = !isNaN(Number(text)) && text !== '';

  const baseClasses = [
    'w-max flex items-center justify-center gap-2 border border-solid select-none border-neutral-700 !border-opacity-[12%]',
    isRounded ? 'rounded-full' : 'rounded-md' // rounded 6px
  ];

  const sizeClasses = {
    small: isNumber ? 'min-w-5 h-5 px-1 leading-[14px]' : 'h-5 px-1.5 leading-[14px]', // 20px
    medium: isNumber ? 'min-w-6 h-6 px-1 leading-[14px]' : 'h-6 px-2 leading-[14px]', // 24px
    large: isNumber ? 'min-w-7 h-7 px-2 leading-4' : 'h-7 px-2 leading-4' // 28px
  };

  const colorClasses = {
    primary: variant === 'lighter' ? 'bg-primary-50' : 'bg-primary-200',
    violet: variant === 'lighter' ? 'bg-violet-50' : 'bg-violet-200',
    success: variant === 'lighter' ? 'bg-success-50' : 'bg-success-200',
    warning: variant === 'lighter' ? 'bg-warning-50' : 'bg-warning-200',
    danger: variant === 'lighter' ? 'bg-danger-50' : 'bg-danger-200',
    neutral: variant === 'lighter' ? 'bg-neutral-50' : 'bg-neutral-200',
    moss: variant === 'lighter' ? 'bg-moss-50' : 'bg-moss-200',
    'green-light': variant === 'lighter' ? 'bg-green-light-50' : 'bg-green-light-200',
    teal: variant === 'lighter' ? 'bg-teal-50' : 'bg-teal-200'
  };

  return [...baseClasses, sizeClasses[size], colorClasses[color]].join(' ');
};

export const getTextClasses = (size) => {
  const baseClasses = ['font-500 capitalize text-neutral-700'];

  const lineHeightClasses = {
    small: 'leading-[14px]',
    medium: 'leading-[14px]',
    large: 'leading-[16px]'
  };

  const sizeClasses = {
    small: 'text-[12px]',
    medium: 'text-[12px]',
    large: 'text-[14px]'
  };

  return [...baseClasses, sizeClasses[size], lineHeightClasses[size]].join(' ');
};

export const getIconSize = (size) => (size === 'large' ? 18 : size === 'medium' ? 16 : 14);
